import(/* webpackMode: "eager", webpackExports: ["Sidebar"] */ "D:\\Project\\NDS\\hq\\wjpncma\\wjpncma-nextjs15\\src\\components\\sidebar.tsx");
